import { homeIcon, toClassicIcon } from "common/defaultIcons";
import {
  LAYOUTS,
  MENU_SECTIONS,
  TEACHER_ROLES,
  USER_ROLES,
} from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { HOME_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    path: "/home",
    name: HOME_ROUTE_NAMES.MAIN,
    component: () => import("home/pages/HomePage.vue"),
    meta: {
      title: "Home",
      // Everyone a teacher is, except a webmaster: they sit in TEACHER_ROLES
      // for every other route, but they browse a school from the webmaster
      // module and Home would draw them four empty cards. Excluding them here
      // covers the menu entry and Startpage's redirect at once, because both
      // read this list.
      roleRequired: [
        ...TEACHER_ROLES.filter((role) => role !== USER_ROLES.WEBMASTER),
        USER_ROLES.STUDENT,
      ],
      isMenuItem: true,
      menuSection: MENU_SECTIONS.MAIN,
      // Home is the first item in the menu; Menu.vue lifts it into its own
      // section above the meetings/classroom groups.
      menuOrder: 0,
      icon: toClassicIcon(homeIcon),
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
  },
];

export default routes;
export { HOME_ROUTE_NAMES };
